import { z } from "zod";
import { computeMinutesFromHours } from "../../../../../common/utils/cargaHorariaUtils";

/**
 * HabilidadeSchema
 */

export const HabilidadeSchema = z.object({
  habilidade: z.string(),
  descricao: z.string(),
});

/**
 * HabilidadeForm
 */

export type HabilidadeForm = z.infer<typeof HabilidadeSchema>;

/**
 * Default value
 */

export const defaultHabilidadeForm: Partial<HabilidadeForm> = {
}